import { CURRENCY_INPUT_DEFAULTS } from '@pequity/shared/ui';
import { BACKEND_DATA_INPUT_TYPE_MAP, type DisplayLayoutFlat, type Field } from '@/ccpv2/types';
import { DEFAULT_CURRENCY_DISPLAY } from '@/ccpv2/types/constants';

const TITLE_FROM_DISPLAY_NAME = ['Employee Name'];

export const createBulkUpdateFields = (displayLayouts: DisplayLayoutFlat[]): Field[] => {
  return displayLayouts
    .filter(
      // only include editable fields, excluding the EID identifier field
      (displayLayout) => displayLayout.editable && displayLayout.name !== 'co_employee_id'
    )
    .map((displayLayout) => {
      const fieldType =
        displayLayout.is_list === true
          ? 'inputSelectText'
          : BACKEND_DATA_INPUT_TYPE_MAP[displayLayout.type] || 'inputText';
      const label = TITLE_FROM_DISPLAY_NAME.includes(displayLayout.title)
        ? displayLayout.display_name
        : displayLayout.title;

      const res: Field = {
        displayLayoutId: displayLayout.id,
        data_name: displayLayout.data_name,
        name: displayLayout.name,
        min: displayLayout.min,
        max: displayLayout.max,
        label,
        hidden: false,
        required: false,
        disabled: false,
        validation: null,
        maxlength: null,
        fieldType,
        roundTo: displayLayout.round_to,
        requiredJustification: displayLayout.required_justification,
        precision: displayLayout.decimal_precision || CURRENCY_INPUT_DEFAULTS.precision,
        placeholder: '',
        recommendedValue: '',
        timezone: '',
        // Wave fields cannot be searchable - they cause crashes when search is enabled
        searchable: displayLayout.is_list === true && displayLayout.type !== 'wave',
        valueIsObject: displayLayout.is_list === true || displayLayout.type === 'wave',
        currency: '',
        currencyDisplay: DEFAULT_CURRENCY_DISPLAY,
        compoundLayouts: [],
      };

      return res;
    });
};
